import { lazy } from "react";

export { COUNTERPARTY_PATH } from "./path";
export const CounterpartyPage = lazy(() => import("./page"));
